//
//
//
//
//
//
//
//
//
//
//
//
//

import List from "@/components/RegionAccount/List";
export default {
  name: "ProvinceManageList",
  components: { List },
  data() {
    return {
      accountType: "province",
    };
  },
};
